import { createDocumentPage, getDocumentTextForType } from "./documentBaseUtils";

export function generatePrintPropertyTransferHtml(config, data, user, breakNewPage = false) {
    const { getDocumentText } = getDocumentTextForType(data, config);
    return createDocumentPage({title: 'DECLARAÇÃO', documentText: getDocumentText('TRANSFERENCIA_PROPRIEDADE'), config, data, user}, {showUserName: true, compact: true, breakNewPage: breakNewPage});
}
